import * as Styled from './styles'

export default function ButtonMenu({ link }) {
  return <Styled.Button onClick={link}>Acessar Painel</Styled.Button>
}
